<template>
  <div>
    <PageWrapper>
      <template>
        <b-form @submit.prevent="submit" class="margin-top-24 form-wrapper">
          <FormLoading :loading="getLoading" :count="5">
            <template>
              <b-row class="margin-0">
                <b-col cols="12" class="padding-0">
                  <Input
                    :title="$lang.username"
                    :label="$lang.username"
                    :placeholder="$lang.username"
                    :infoTooltip="$lang.username_valid_message"
                    :value="form.username"
                    name="username"
                    id="username"
                    type="text"
                    :minLength="lengthNumber11"
                    :maxLength="lengthNumber11"
                    :vuelidateObj="$v.form.username"
                    @input="input"
                    @focus="resetValidation"
                    @blur="checkValidation"
                  />
                </b-col>
                <b-col cols="12" class="padding-0">
                  <Input
                    :title="`${$lang.email} (${$lang.optional})`"
                    :label="$lang.email"
                    :placeholder="$lang.email"
                    :value="form.email"
                    name="email"
                    id="email"
                    type="email"
                    :vuelidateObj="$v.form.email"
                    @input="input"
                    @focus="resetValidation"
                    @blur="checkValidation"
                  />
                </b-col>
                <b-col cols="12" class="padding-0 margin-bottom-22">
                  <b-row class="margin-0 flex-between">
                    <b-col cols="12" sm="" class="padding-0">
                      <Input
                        :title="$lang.mobile"
                        :label="$lang.mobile"
                        :placeholder="$lang.mobile"
                        :value="form.mobile"
                        name="mobile"
                        id="mobile"
                        type="number"
                        :vuelidateObj="$v.form.mobile"
                        :disabled="true"
                        rowClass=""
                        @input="input"
                        @focus="resetValidation"
                        @blur="checkValidation"
                      />
                    </b-col>
                    <b-col
                      cols="12"
                      sm="4"
                      class="padding-0 padding-right-8 mobile-padding-0 margin-top-25 mobile-margin-top-8"
                    >
                      <Button
                        wrapperClass="width-percent-100"
                        variant="outline-primary"
                        :text="$lang.change_mobile"
                        contentClass="justify-content-center"
                        @click="showChangeMobileModal"
                      />
                    </b-col>
                  </b-row>
                </b-col>
                <b-col cols="12" class="padding-0 margin-bottom-22">
                  <b-row class="margin-0 flex-between">
                    <b-col cols="12" sm="" class="padding-0">
                      <Input
                        :title="$lang.password"
                        :label="$lang.password"
                        :placeholder="$lang.password"
                        :value="form.password"
                        name="password"
                        id="password"
                        type="password"
                        autocomplete="new-password"
                        :vuelidateObj="$v.form.password"
                        :disabled="true"
                        :isPasswordTogglerIcon="false"
                        rowClass="color-complementary-200"
                        @input="input"
                        @focus="resetValidation"
                        @blur="checkValidation"
                      />
                    </b-col>
                    <b-col
                      v-if="checkPermission(permissions, ['admin', 'edit'])"
                      cols="12"
                      sm="4"
                      class="padding-0 padding-right-8 mobile-padding-0 margin-top-25 mobile-margin-top-8"
                    >
                      <Button
                        wrapperClass="width-percent-100"
                        variant="outline-primary"
                        :text="$lang.change_pass"
                        contentClass="justify-content-center"
                        @click="showChangePasswordModal"
                      />
                    </b-col>
                  </b-row>
                </b-col>
                <b-col cols="12" class="flex-end padding-0">
                  <Button
                    variant="primary"
                    :text="$lang.correction"
                    contentClass="justify-content-center"
                    :loading="loading"
                    @click="submit"
                  />
                </b-col>
              </b-row>
            </template>
          </FormLoading>
        </b-form>
      </template>
    </PageWrapper>
    <Modal
      :show="changePasswordModal"
      :title="$lang.change_password"
      :closeOnBackdrop="false"
      :hasClose="false"
      :hasFooter="false"
      size="sm"
      @close="closeChangePasswordModal"
    >
      <template #body>
        <ChangePassword
          @close="closeChangePasswordModal"
          @reload="getUserData"
        />
      </template>
    </Modal>
    <Modal
      :show="changeMobileModal"
      :title="changeMobileTitle"
      :closeOnBackdrop="false"
      :hasClose="false"
      :hasFooter="false"
      size="sm"
      @close="closeChangeMobileModal"
    >
      <template #body>
        <ChangeMobile
          :userData="form"
          @getTitle="updateChangeMobileTitle"
          @close="closeChangeMobileModal"
          @reload="getUserData"
        />
      </template>
    </Modal>
  </div>
</template>

<script>
import inputMixin from "@/mixin/inputMixin.vue";
import PageWrapper from "@/components/re-design/wrappers/PageWrapper.vue";
import ChangePassword from "./components/ChangePassword.vue";
import ChangeMobile from "./components/ChangeMobile.vue";
import { FormLoading, Input, Button } from "@/components/re-design/forms";
import Modal from "@/components/re-design/modal/Modal.vue";
import { required } from "vuelidate/lib/validators";
import { mapActions } from "vuex";
import { pathOr } from "ramda";
import {
  checkPermission,
  generateApiUrl,
  generateError,
  toastAlert,
} from "@/shared/utils";
import { changeUserInfo, getProfileUser } from "../../services";

export default {
  mixins: [inputMixin],
  components: {
    PageWrapper,
    ChangePassword,
    ChangeMobile,
    FormLoading,
    Input,
    Button,
    Modal,
  },
  validations() {
    return {
      form: {
        username: { required },
        email: {},
        mobile: {},
        password: {},
      },
    };
  },
  data() {
    return {
      form: {
        username: null,
        email: null,
        mobile: null,
        password: 123456789999,
      },
      parvandehCode: this.$route.params.code,
      loading: false,
      getLoading: false,
      code: this.$route.params.code,
      permissions: [],
      changePasswordModal: false,
      changeMobileModal: false,
      changeMobileTitle: null,
    };
  },
  mounted() {
    this.getUserData();
  },
  methods: {
    ...mapActions(["setAction"]),
    pathOr,
    checkPermission,
    generateApiUrl,
    setMobileHeaderTitle() {
      const name = pathOr("", ["name"], {});
      const family = pathOr("", ["family"], {});
      const title = `${this.$lang.change_user_information} ${name} ${family}`;
      this.setAction({
        key: "mobileHeaderTitleText",
        value: title,
      });
    },
    async getUserData() {
      try {
        this.getLoading = true;
        const response = await getProfileUser();
        const { username, mobile, email, permissions } = response;
        this.form.username = username;
        this.form.mobile = mobile;
        this.form.email = email;
        this.permissions = permissions;
      } catch (error) {
        generateError(error);
      } finally {
        this.getLoading = false;
      }
    },
    async submit() {
      this.$v.$touch();
      if (this.$v.$anyError || this.loading) return;
      try {
        this.loading = true;
        const { username, email } = this.form;
        const response = await changeUserInfo(username, email);
        const { message } = response;
        toastAlert(message);
      } catch (error) {
        generateError(error);
      } finally {
        this.loading = false;
      }
    },
    showChangePasswordModal() {
      this.changePasswordModal = true;
    },
    closeChangePasswordModal() {
      this.changePasswordModal = false;
    },
    showChangeMobileModal() {
      this.changeMobileModal = true;
    },
    closeChangeMobileModal() {
      this.changeMobileModal = false;
    },
    updateChangeMobileTitle(value) {
      this.changeMobileTitle = value;
    },
  },
};
</script>
